import { render } from "./dataDown.vue?vue&type=template&id=1d4708dc&scoped=true"
import script from "./dataDown.vue?vue&type=script&lang=js"
export * from "./dataDown.vue?vue&type=script&lang=js"

import "./dataDown.vue?vue&type=style&index=0&id=1d4708dc&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-1d4708dc"

export default script